import { render, staticRenderFns } from "./useVideo.vue?vue&type=template&id=af68e1f4&scoped=true&"
import script from "./useVideo.vue?vue&type=script&lang=js&"
export * from "./useVideo.vue?vue&type=script&lang=js&"
import style0 from "./useVideo.vue?vue&type=style&index=0&id=af68e1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af68e1f4",
  null
  
)

export default component.exports